var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ComponentBaseComponent } from "../../../core/component-base.component";
import { AlertType } from "../../../enums/alert-type";
import { Message } from "../../../localization/message";
import { EndingInputDataBase } from "../../../models/ending";
import { SupplierUrlEncryptionInputData } from "../../../models/supplier-url-encryption";
import { EndService } from "../../../services/end.service";
import { Utilities } from "../../../utils/utilities";
import { CheesecakeStep } from "../../../enums/cheesecake-step";
import { SetStatusResponseType } from "../../../enums/ending-page-response-type.enum";
import { URLType } from "../../../enums/url-type";
import { Exception, isApiError } from "../../../core/exception";
import { Respondent } from "../../../models/respondent";
import { SampleCubeUserBase } from "../../../models/samplecube-user";
import { RvidData } from "../../../models/rvid";
var SetPixelURLComponent = /** @class */ (function (_super) {
    __extends(SetPixelURLComponent, _super);
    function SetPixelURLComponent(title) {
        var _this = _super.call(this, title) || this;
        _this.imagePixelUrl = "";
        _this.javaScriptUrl = "";
        _this.redirectUrl = "";
        _this.iframeurl = "";
        _this.comScoreImageUrl = "";
        return _this;
    }
    Object.defineProperty(SetPixelURLComponent.prototype, "hasSafeIframeUrl", {
        get: function () {
            return !!this.iframeurl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SetPixelURLComponent.prototype, "hasSafeRedirectUrl", {
        get: function () {
            return !!this.redirectUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SetPixelURLComponent.prototype, "hasSafeJavaScriptUrl", {
        get: function () {
            return !!this.javaScriptUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SetPixelURLComponent.prototype, "hasSafeImagePixelUrl", {
        get: function () {
            return !!this.imagePixelUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SetPixelURLComponent.prototype, "hasSafeComScoreImageUrl", {
        get: function () {
            return !!this.comScoreImageUrl;
        },
        enumerable: true,
        configurable: true
    });
    return SetPixelURLComponent;
}(ComponentBaseComponent));
export { SetPixelURLComponent };
var SetClientStatusComponent = /** @class */ (function (_super) {
    __extends(SetClientStatusComponent, _super);
    function SetClientStatusComponent(endService, sanitizer) {
        var _this = _super.call(this, "Loading ...") || this;
        _this.endService = endService;
        _this.sanitizer = sanitizer;
        _this.endingInputData = null;
        _this.endingOutputData = null;
        _this.supplierUrlEncryptionInputData = new SupplierUrlEncryptionInputData();
        _this.win = false;
        _this.fail = false;
        _this.quotaFail = false;
        _this.sessionStorageService.set("sc.step", CheesecakeStep.Landed);
        return _this;
    }
    Object.defineProperty(SetClientStatusComponent.prototype, "safeIframeUrl", {
        get: function () {
            return this.sanitizer.bypassSecurityTrustUrl(this.iframeurl);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SetClientStatusComponent.prototype, "safeRedirectUrl", {
        get: function () {
            return this.sanitizer.bypassSecurityTrustUrl(this.redirectUrl);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SetClientStatusComponent.prototype, "safeJavaScriptUrl", {
        get: function () {
            return this.sanitizer.bypassSecurityTrustUrl(this.javaScriptUrl);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SetClientStatusComponent.prototype, "safeImagePixelUrl", {
        get: function () {
            return this.sanitizer.bypassSecurityTrustUrl(this.imagePixelUrl);
        },
        enumerable: true,
        configurable: true
    });
    SetClientStatusComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self, urlParams, data, _a, routedSetStatusResponse, respondent, user, polfishResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _super.prototype.ngOnInit.call(this);
                        self = this;
                        urlParams = Utilities.parseQuery();
                        // if (!!!urlParams["rid"]) {
                        //   const respondent = self.cachedRespondent;
                        //   let respondentToken = respondent.respondentToken;
                        //   respondentToken += respondent.isTest ? "test" : "";
                        //   urlParams["rid"] = respondentToken;
                        // }
                        self.endingInputData = EndingInputDataBase.processParameters(urlParams);
                        if (!!!self.endingInputData.respondent.respondentToken) {
                            self.displayAlert(Message.InvalidRespondent, AlertType.Error);
                            return [2 /*return*/];
                        }
                        if (self.endingInputData.respondent.returnStatusId === 0) {
                            self.displayAlert(Message.InvalidReturnStatus, AlertType.Error);
                            return [2 /*return*/];
                        }
                        this.checkForTestRespondent();
                        data = new RvidData(self.localStorageService.get("sc.rvid.data"));
                        if (!!data) {
                            self.endingInputData.relevantId = data.RVid || '';
                            self.endingInputData.fraudProfileScore = Math.round(data.FraudRiskProbability) || 0;
                            self.endingInputData.country = data.Country || '';
                        }
                        _a = self;
                        return [4 /*yield*/, self.endService.setStatus(self.endingInputData, function (error) {
                                throw new Exception({
                                    message: error.message,
                                    data: isApiError(error.error) ? error.error : null
                                });
                            })];
                    case 1:
                        _a.endingOutputData = _b.sent();
                        if (self.endingOutputData.respondent.isTest) {
                            self.sessionStorageService.set("sc.respondent.test", self.endingOutputData.respondent);
                            self.sessionStorageService.remove("sc.respondent");
                        }
                        else {
                            self.sessionStorageService.set("sc.respondent", self.endingOutputData.respondent);
                            self.sessionStorageService.remove("sc.respondent.test");
                        }
                        if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.Success) {
                            self.sessionStorageService.clear();
                            self.displayAlert(Message.ThanksForParticipation);
                            return [2 /*return*/];
                        }
                        if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.Redirect) {
                            self.sessionStorageService.clear();
                            if (self.endingOutputData.urlType == URLType.None) {
                                window.location.href = self.endingOutputData.redirectUrl;
                            }
                            else if (self.endingOutputData.urlType === URLType.JavaScript) {
                                self.javaScriptUrl = self.redirectUrl;
                            }
                            else if (self.endingOutputData.urlType === URLType.IFrame) {
                                this.iframeurl = self.redirectUrl;
                            }
                            else if (self.endingOutputData.urlType === URLType.ImagePixel) {
                                this.imagePixelUrl = self.redirectUrl;
                            }
                            return [2 /*return*/];
                        }
                        if (self.endingOutputData.hasPages()) {
                            if (self.sessionStorageService.get("sc.qualifications")) {
                                self.sessionStorageService.remove("sc.qualifications");
                            }
                            if (self.endingOutputData.dropCookie) {
                                self.sessionStorageService.set("sc.qualifications", self.endingOutputData.pages);
                            }
                            else {
                                self.sessionStorageService.set("sc.qualifications", self.endingOutputData.pages);
                            }
                        }
                        if (self.endingOutputData.dropCookie) {
                            self.sessionStorageService.set("sc.vendorurl", self.endingOutputData.redirectUrl);
                            self.sessionStorageService.set("sc.urltype", self.endingOutputData.urlType);
                            this.navigateTo("/survey/after-complete-consent", true);
                        }
                        if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.AfterComplete) {
                            self.sessionStorageService.set("sc.vendorurl", self.endingOutputData.redirectUrl);
                            self.sessionStorageService.set("sc.urltype", self.endingOutputData.urlType);
                            this.navigateTo("/survey/after-complete", true);
                        }
                        if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.AfterCompleteReconfirmContact) {
                            self.sessionStorageService.set("sc.vendorurl", self.endingOutputData.redirectUrl);
                            self.sessionStorageService.set("sc.urltype", self.endingOutputData.urlType);
                            this.navigateTo("/survey/after-complete-reconfirm-contact", true);
                        }
                        if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.Routed) {
                            routedSetStatusResponse = self.endingOutputData;
                            respondent = new Respondent(self.sessionStorageService.get(self.isTestUrl ? "sc.respondent.test" : "sc.respondent"));
                            respondent.id = routedSetStatusResponse.respondentId;
                            respondent.surveyId = routedSetStatusResponse.surveyId;
                            respondent.respondentToken = routedSetStatusResponse.respondentToken;
                            self.sessionStorageService.set(self.isTestUrl ? "sc.respondent.test" : "sc.respondent", respondent);
                            user = SampleCubeUserBase.instanceFrom(self.localStorageService.get(self.isTestUrl ? "sc.profile.test" : "sc.profile"));
                            if (!user && user.userId < 1) {
                                user = self.localStorageService.get(self.isTestUrl ? "sc.profile.test" : "sc.profile");
                            }
                            self.sessionStorageService.set("sc.samplechainenable", routedSetStatusResponse.isSampleChainEnabled);
                            self.sessionStorageService.set("sc.verifyrelevantid", routedSetStatusResponse.verifyRelevantId);
                            self.sessionStorageService.remove("sc.sample.chain.data");
                            self.sessionStorageService.set("sc.sampleChainDestinationPlatformId", routedSetStatusResponse.sampleChainDestinationPlatformId);
                            self.sessionStorageService.set("sc.sampleChainDestinationSurveyNumber", routedSetStatusResponse.sampleChainDestinationSurveyNumber);
                            self.sessionStorageService.set("sc.verifyrfgfingerprint", routedSetStatusResponse.verifyRFGFingerPrint);
                            polfishResponse = self.endingOutputData;
                            self.sessionStorageService.set("sc.ispollfishenabled", self.isTestUrl === true ? false : polfishResponse.isPollfishEnabled);
                            self.sessionStorageService.set("sc.isplrouterenabled", self.isTestUrl === true ? false : polfishResponse.isPLRouterEnabled);
                            self.sessionStorageService.set("sc.clientinvokeurl", self.isTestUrl === true ? false : polfishResponse.clientInvokeUrl);
                            self.sessionStorageService.set("sc.isRecontact", routedSetStatusResponse.isRecontact);
                            self.sessionStorageService.set("sc.isPIDRouting", routedSetStatusResponse.isPIDRouting);
                            self.sessionStorageService.set("sc.originaluserid", routedSetStatusResponse.originalUserId);
                            self.ngOnDestroy();
                            self.navigateTo("/survey", true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SetClientStatusComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    SetClientStatusComponent.prototype.checkForTestRespondent = function () {
        var self = this;
        if (self.endingInputData.respondent.respondentToken.indexOf("test") >= 0) {
            self.endingInputData.respondent.isTest = true;
            self.endingInputData.respondent.respondentToken = self.endingInputData.respondent.respondentToken.replace("test", "");
        }
    };
    return SetClientStatusComponent;
}(SetPixelURLComponent));
export { SetClientStatusComponent };
